import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { SharedComponentsModule } from '../shared/components/shared-components.module';

import { ClientBackbuttonActionComponent } from './components/client-backbutton-action/client-backbutton-action.component';
import { ClientConfirmActionComponent } from './components/client-confirm-action/client-confirm-action.component';
import { ClientLoadFailedComponent } from './components/client-load-failed/client-load-failed.component';
import { ConfirmIssueChangeComponent } from './components/confirm-issue-change/confirm-issue-change.component';
import { IdleWarningComponent } from './components/idle-warning/idle-warning.component';
import { BrowserDetectionComponent } from './components/browser-detection/browser-detection.component';
import { SystemMessagePopupComponent } from './components/system-message-popup/system-message-popup.component';
import { Error404Component } from './components/error-404/error-404.component';
import { AccessDeniedComponent } from './components/access-denied/access-denied.component';
import { ComingSoonComponent } from './components/coming-soon/coming-soon.component';
import { MaintenanceScreenComponent } from './components/maintenance-screen/maintenance-screen.component';
import { NoModulesPageComponent } from './components/no-modules-page/no-modules-page.component';
import { WorkspaceNotAssignedComponent } from './components/workspace-not-assigned/workspace-not-assigned.component';

import { GlobalService } from './services/global.service';
import { ContextFactoryService } from './services/context-factory.service';
import { JcdFactoryService } from './services/jcd-factory.service';
import { JsonObjectFactoryService } from './services/json-object-factory.service';
import { AdminFactoryService } from './services/admin-factory.service';
import { ModalFactoryService } from './services/modal-factory.service';
import { MenuDataService } from './services/menu-data.service';
import { MessageService } from './services/message.service';

@NgModule({ declarations: [
        ClientBackbuttonActionComponent,
        ClientConfirmActionComponent,
        ClientLoadFailedComponent,
        ConfirmIssueChangeComponent,
        IdleWarningComponent,
        BrowserDetectionComponent,
        SystemMessagePopupComponent,
        Error404Component,
        AccessDeniedComponent,
        ComingSoonComponent,
        MaintenanceScreenComponent,
        NoModulesPageComponent,
        WorkspaceNotAssignedComponent
    ],
    exports: [
        ClientBackbuttonActionComponent,
        ClientConfirmActionComponent,
        ClientLoadFailedComponent,
        ConfirmIssueChangeComponent,
        IdleWarningComponent,
        BrowserDetectionComponent,
        SystemMessagePopupComponent,
        Error404Component,
        AccessDeniedComponent,
        ComingSoonComponent,
        MaintenanceScreenComponent,
        NoModulesPageComponent,
        WorkspaceNotAssignedComponent
    ], imports: [CommonModule,
        FormsModule,
        MatSnackBarModule,
        MatDialogModule,
        SharedComponentsModule], providers: [
        GlobalService,
        ContextFactoryService,
        JcdFactoryService,
        JsonObjectFactoryService,
        AdminFactoryService,
        ModalFactoryService,
        MenuDataService,
        MessageService] })
export class GlobalModule {}
